<div rds-dialog-header>
  <h2 rds-dialog-title class="ui-heading-4-bold">{{ data.title }}</h2>
</div>
<div rds-dialog-content>
  <div class="content">
    <rds-icon
      [icon]="data.icon"
      namespace="filled"
      class="icon"
      [style.fill]="data.iconColor"
    />
    <div class="description">
      <p class="ui-body-m">{{ data.message }}</p>
      <p class="ui-body-m">{{ data.warning }}</p>
    </div>
  </div>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ data.cancelText || "Cancel" }}
  </button>
  <button rds-primary-button size="m" [rds-dialog-close]="true">
    {{ data.confirmText || "Confirm" }}
  </button>
</div>
